// extracted by mini-css-extract-plugin
export default {"container":"spinner_container__8pLWN","containFully":"spinner_containFully__RVTZD","text":"spinner_text__TU+y7"};